import React, { Component } from 'react';
import filter from 'lodash/filter';
import map from 'lodash/map';
import { TextInput, PagerButtons } from 'sure-components';
import Select from 'react-select';
import PropTypes from 'prop-types';
import PlanDisclaimer from 'shared/lib/components/PlanDisclaimer';
import * as analytics from 'shared/lib/analytics';
import './BaggageFlightDetailsView.css';

const propTypes = {
  baggageAirline: PropTypes.string,
  baggageConfirmationNumber: PropTypes.string,
  disclaimer: PropTypes.string,
  getAirlines: PropTypes.func,
  saveBaggageAirline: PropTypes.func,
  saveBaggageConfirmationViewNumber: PropTypes.func,
};

const defaultProps = {
  disclaimer: null,
};

class BaggageFlightDetailsView extends Component {
  componentDidMount() {
    analytics.page('BRB - Trip Info', { category: 'user' });
  }

  getAirlineOptions() {
    return this.props.getAirlines().then(airlines => {
      const brbAirlines = filter(airlines, { brb_allowed: true });
      const options = map(brbAirlines, airline => {
        return {
          value: airline.fs,
          label: `${airline.name} (${airline.fs})`,
        };
      });

      return { options, complete: true };
    });
  }

  handleAirlineSelect(option) {
    if (option) {
      this.props.saveBaggageAirline(option.value);
    } else {
      this.props.saveBaggageAirline(null);
    }
  }

  handleConfirmationNumberChange() {
    this.props.saveBaggageConfirmationViewNumber(this.confirmationNumber.value);
  }

  handleBack() {
    this.props.navTo('/baggage-protection/address');
  }

  handleNext() {
    this.props.saveBaggageConfirmationViewNumber(this.confirmationNumber.value);
    this.props.navTo('/baggage-protection/passenger');
  }

  render() {
    return (
      <div className="BaggageFlightDetailsView Container Container--small">
        <h1 className="BaggageFlightDetailsView-heading">
          Add your trip information to help us track and protect your baggage.
        </h1>
        <form
          className="BaggageFlightDetailsView-form"
          onSubmit={e => this.handleNext(e)}
        >
          <div className="BaggageFlightDetailsView-form-fields">
            <label>What airline are you flying with?</label>
            <Select.Async
              className="SureSelect BaggageFlightDetailsView-airlineField"
              name="airline"
              loadOptions={this.getAirlineOptions.bind(this)}
              placeholder="Airline"
              value={this.props.baggageAirline}
              required
              onChange={this.handleAirlineSelect.bind(this)}
            />
            <label>What is your confirmation #?</label>
            <TextInput
              name="confirmationNumber"
              placeholder="Confirmation number"
              required
              ref={c => (this.confirmationNumber = c)}
              value={this.props.baggageConfirmationNumber}
              onChange={this.handleConfirmationNumberChange.bind(this)}
            />
          </div>
          <input
            type="submit"
            style={{ display: 'none' }}
            ref={c => (this.inputSubmit = c)}
          />
          <PagerButtons
            className="BaggageFlightDetailsView-cta"
            onBack={this.handleBack.bind(this)}
            onNext={this.handleNext.bind(this)}
            isNextDisabled={
              !this.props.baggageAirline ||
              !this.props.baggageConfirmationNumber
            }
          />
        </form>
        <PlanDisclaimer text={this.props.disclaimer} />
      </div>
    );
  }
}

BaggageFlightDetailsView.propTypes = propTypes;
BaggageFlightDetailsView.defaultProps = defaultProps;

export default BaggageFlightDetailsView;
